import { Command } from '../../_base/actionBus/Command';

export class SelectUnit extends Command {
    constructor(public unitId: number) { super(); }
}
